import { searchHandler, sortTargetList } from 'helpers'
import { useEffect, useMemo, useState } from 'react'
import { TargetPayloadType } from 'storeTypes'

interface UseSearchTargetListProps {
    targetList: TargetPayloadType[]
}

export const useSearchTargetList = ({
    targetList
}: UseSearchTargetListProps) => {
    const [targetListSearchValue, setTargetListSearchValue] = useState('')
    const [targetListSearchResults, setTargetListSearchResults] =
        useState(targetList)

    const searchTargetList = () => {
        if (targetListSearchValue.trim().length > 2) {
            const results = searchHandler(targetList || [], {
                fullname: targetListSearchValue,
                reversed_fullname: targetListSearchValue,
                client_code: targetListSearchValue,
                phone: targetListSearchValue
            })
            return setTargetListSearchResults(results)
        }
        setTargetListSearchResults(targetList)
    }

    const onTargetListSearchChange = (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        e.preventDefault()
        const { value } = e.target
        setTargetListSearchValue(value)
    }

    const sortedTargetList = useMemo(
        () => sortTargetList(targetListSearchResults || []),
        [targetListSearchResults]
    )

    useEffect(() => {
        searchTargetList()
    }, [targetList, targetListSearchValue])

    return {
        targetListSearchValue,
        targetListSearchResults,
        onTargetListSearchChange,
        sortedTargetList
    }
}
